import React from "react";
import "./style.css";

export default function CategoryCard({name,uid,slug,selected}) {
    return(
        <div className={selected ? "category_card selected" : "category_card"}>
            <p>{name}</p>
        </div>

    )
}